<template>
  <div class="page">
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow"
                        :pageName="clearPhoneNumDialog.pageName"
                        @dialogClose="clearDialogClose"></ClearPhoneNoDialog>

    <el-drawer class="visitor-drawer" :visible.sync="addDrawerShow" :with-header="false" direction="rtl" size="500px">
      <div class="drawer-header">
        <h3>添加人员</h3>
      </div>
      <div class="drawer-content">
        <el-form ref="addForm" class="drawer-form" :rules="rules" :model="addForm" size="mini">
          <el-form-item label="访客姓名" prop="name" label-width="80px">
            <el-input v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="tel" label-width="80px">
            <el-input v-model="addForm.tel"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="company" label-width="80px">
            <el-input v-model="addForm.company"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="ic" label-width="80px" v-if="visitorShowSetting.showIC">
            <el-input v-model="addForm.ic"></el-input>
          </el-form-item>
          <el-form-item label="国籍" prop="nationality" label-width="80px" v-if="visitorShowSetting.showNationality">
            <el-input v-model="addForm.nationality"></el-input>
          </el-form-item>
          <el-form-item label="护照号码" prop="tag" label-width="80px" v-if="visitorShowSetting.showPassport">
            <el-input v-model="addForm.tag"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email" label-width="80px" v-if="visitorShowSetting.showEmail">
            <el-input v-model="addForm.email"></el-input>
          </el-form-item>
          <el-form-item label="车牌号码" prop="car" label-width="80px">
            <el-input v-model="addForm.car"></el-input>
          </el-form-item>
          <el-form-item label="地址信息" prop="address" label-width="80px">
            <el-input v-model="addForm.address"></el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="comments" label-width="80px">
            <el-input v-model="addForm.comments"></el-input>
          </el-form-item>
        </el-form>

      </div>
      <div class="drawer-bottom">
        <el-button size="mini" type="primary" @click="addAddVisitorClick">确 定</el-button>
        <span style="width: 100px"></span>
        <el-button size="mini" @click="addDrawerShow = false">取 消</el-button>
      </div>
    </el-drawer>

    <el-drawer class="visitor-drawer" :visible.sync="updateDrawerShow" :with-header="false" direction="rtl"
               size="500px">
      <div class="drawer-header">
        <h3>修改信息</h3>
      </div>
      <div class="drawer-content">
        <el-form ref="addForm" class="drawer-form" :rules="rules" :model="selectVisitor" size="mini">
          <el-form-item label="访客姓名" prop="name" label-width="80px">
            <el-input v-model="selectVisitor.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="tel" label-width="80px">
            <el-input v-model="selectVisitor.tel"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="company" label-width="80px">
            <el-input v-model="selectVisitor.company"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="ic" label-width="80px" v-if="visitorShowSetting.showIC">
            <el-input v-model="selectVisitor.ic"></el-input>
          </el-form-item>
          <el-form-item label="护照号码" prop="tag" label-width="80px" v-if="visitorShowSetting.showPassport">
            <el-input v-model="selectVisitor.tag"></el-input>
          </el-form-item>
          <el-form-item label="国籍" prop="" label-width="80px" v-if="visitorShowSetting.showNationality">
            <el-input v-model="selectVisitor.nationality"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email" label-width="80px" v-if="visitorShowSetting.showEmail">
            <el-input v-model="selectVisitor.email"></el-input>
          </el-form-item>
          <el-form-item label="车牌号码" prop="car" label-width="80px">
            <el-input v-model="selectVisitor.car"></el-input>
          </el-form-item>
          <el-form-item label="地址信息" prop="address" label-width="80px">
            <el-input v-model="selectVisitor.address"></el-input>
          </el-form-item>

          <el-form-item label="访客卡号" prop="cardNo" label-width="80px">
            <el-input v-model="selectVisitor.cardNo"></el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="comments" label-width="80px">
            <el-input v-model="selectVisitor.comments"></el-input>
          </el-form-item>
          <el-form-item label="访客类型" prop="type" label-width="80px">
            <el-select v-model="selectVisitor.type" placeholder="请选择" @change="onVisitorTypeSelectChange">
              <el-option label="普通访客" value="common"></el-option>
              <el-option label="常访访客" value="usual"></el-option>
              <el-option label="供应商访客" value="provide"></el-option>
              <el-option label="黑名单访客" value="black"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="对接员工" label-width="80px" v-if="selectVisitor.type === 'usual'">
            <el-select v-model="selectVisitor.contactEmployee" value-key="code" filterable remote
                       :remote-method="employeeFilter" clearable placeholder="请选择" :loading="searchLoading">
              <el-option v-for="item in employeeList" :key="item.code"
                         :label="`${item.name} | ${item.tel} | ${item.departmentName}`" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="有效期限" label-width="80px" required v-if="selectVisitor.type === 'usual'">
            <el-select v-model="selectVisitor.usualExtraType" placeholder="请选择">
              <el-option label="永久有效" value="none"></el-option>
              <el-option label="自定义有效范围" value="have"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" label-width="80px" required v-if="selectVisitor.usualExtraType === 'have'">
            <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                            v-model="selectVisitor.usualExtraBegin" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" label-width="80px" required v-if="selectVisitor.usualExtraType === 'have'">
            <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                            v-model="selectVisitor.usualExtraEnd" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-form>

      </div>
      <div class="drawer-bottom">
        <el-button size="mini" type="primary" @click="onUpdateVisitorClick">确 定</el-button>
        <span style="width: 100px"></span>
        <el-button size="mini" @click="updateDrawerShow = false">取 消</el-button>
      </div>
    </el-drawer>
    <el-drawer class="visitor-drawer" :with-header="false" :visible.sync="addBatchDrawerShow" size="550px">

      <div class="my-header">
        <div class="header-title-box">批量添加</div>
        <div class="btn-area">
          <span style="width: 124px"></span>
          <el-button size="small" type="primary" @click="downloadExcel">模板下载</el-button>
          <span style="width: 100px"></span>
          <el-upload ref="upload" action="#" :on-change="handleFileChange" :auto-upload="false"
                     :file-list="fileList" :multiple="false" :limit="1">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </div>
      </div>

      <el-main class="my-el-main">


        <div class="main-content">
          <div style="height: 20px"></div>
          <div class="table-area" v-if="userList.length > 0">
            <el-form class="drawer-form" size="mini" v-for="(item, index) in userList" :key="index">
              <el-form-item v-for="(v, k) in excelTable" :key="k" :label="v" label-width="80px"
                            :required="k.indexOf('*') !== -1">
                <el-input :disabled="true" v-model="item[k]"></el-input>
              </el-form-item>
              <el-divider></el-divider>
            </el-form>
          </div>
        </div>
      </el-main>

      <el-footer>
        <div class="footer-content">
          <el-button size="mini" type="primary" @click="onSubmitAddBatch">确认</el-button>
          <el-button size="mini" @click="addBatchDrawerShow = false">取消</el-button>
        </div>
      </el-footer>

    </el-drawer>

    <div class="main-area">
      <div class="header-area">
        <div>
          <el-input size="small" placeholder="请输入姓名或手机号" v-model="searchInput">
            <el-button @click="onSearchClick" slot="append">搜索</el-button>
          </el-input>
          <el-button v-if="hasCommitPermission" type="danger" plain size="mini" style="margin-left: 30px"
                     @click="cleartextShow('黑名单访客')">明文查看
          </el-button>

        </div>

        <div>
          <el-button size="mini" :disabled="!hasCommitPermission" type="primary" @click="onAddClick">添加人员
          </el-button>
          <el-button size="mini" :disabled="!hasCommitPermission" type="success" @click="onAddBatch">批量添加
          </el-button>
        </div>
      </div>
      <div class="mainContainer">
        <el-table :data="tableData" border>
          <el-table-column prop="name" label="姓名" width="140"></el-table-column>
          <el-table-column prop="tel" label="手机号" width="120">
            <template slot-scope="scope">
              <template v-if="phoneNumShow">{{ scope.row.tel }}</template>
              <template v-else>{{ scope.row.tel | phNoFilter }}</template>
            </template>
          </el-table-column>
          <el-table-column prop="ic" label="身份证" v-if="visitorShowSetting.showIC">
            <template slot-scope="scope">
              <template v-if="phoneNumShow">{{ scope.row.ic }}</template>
              <template v-else>{{ scope.row.ic | icNoFilter }}</template>
            </template>
          </el-table-column>
          <el-table-column prop="nationality" label="国籍" v-if="visitorShowSetting.showNationality"></el-table-column>
          <el-table-column prop="tag" label="护照号" v-if="visitorShowSetting.showPassport"></el-table-column>
          <el-table-column prop="email" label="电子邮箱" v-if="visitorShowSetting.showEmail"></el-table-column>
          <el-table-column prop="cardNo" label="访客卡号"></el-table-column>
          <el-table-column prop="company" label="公司"></el-table-column>

          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click="tableUpdate(scope.row)" :disabled="!hasCommitPermission">修改
              </el-button>
              <el-button type="danger" size="mini" @click="tableDel(scope.row)" :disabled="!hasCommitPermission">删除
              </el-button>
            </template>
          </el-table-column>

        </el-table>
        <div class="pager">
          <el-pagination layout="sizes, prev, pager, next, jumper" :total="totalCount" :page-sizes="pageSizes"
                         :page-size.sync="curPageSize" :pager-count="5"
                         :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                         @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {mixin_clearPhoneNumShow, mixin_page_table, mixin_visitor_setting} from "@/utils/mixin";
import {addBatchVisitor, addVisitor, deleteVisitor, getVisitorList, updateVisitor} from "@/api/visitor-api";
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import {to_employee_mixin} from "@/pages/visitor/to_employee_mixin";


export default {
  components: {ClearPhoneNoDialog},
  mixins: [mixin_page_table, mixin_clearPhoneNumShow, to_employee_mixin, mixin_visitor_setting],
  data() {
    return {
      searchInput: '',
      addForm: {
        name: '', tel: '', company: '', comments: '', ic: '',
        tag: '', email: '', car: '', address: '', type: 'black', nationality: '', cardNo: '',
      },
      addDrawerShow: false,
      selectVisitor: {},
      updateDrawerShow: false,

      addBatchDrawerShow: false,
      fileList: [],
      userList: [],
      form: [],
      excelTable: {
        "*访客姓名": "访客姓名",
        "*手机号码": "手机号码",
        "*公司名称": "公司名称",
        "身份证号": "身份证号",
        "国籍": "国籍",
        "护照号码": "护照号码",
        "电子邮箱": "电子邮箱",
        "车牌号码": "车牌号码",
        "地址信息": "地址信息",
        "备注信息": "备注信息",
      },

      employeeList: [],

    } // end  data return
  },

  async mounted() {
    this.refreshTableData()
    await this.setupInviteVisitorSetting()
  },

  methods: {
    refreshTableData() {
      let postData = {
        current: this.curPageIndex,
        size: this.curPageSize,
        type: 'black'
      }
      if (this.searchInput) {
        if (isNaN(this.searchInput)) {
          postData.name = this.searchInput
        } else {
          postData.tel = this.searchInput
        }
      }
      getVisitorList(postData).then(({data}) => {
        if (data.code === 200) {
          this.tableData = data.data.data
          this.totalCount = data.data.totals
        }
      }).catch(error => {
        console.log("getVisitorList err =>", error)
      })

    },

    onSearchClick() {
      this.curPageIndex = 1
      this.refreshTableData()
    },
    onAddClick() {
      this.addDrawerShow = true
      this.addForm = {
        name: '', tel: '', company: '', comments: '', ic: '',
        tag: '', email: '', car: '', address: '', type: 'black'
      }
    },
    onAddBatch() {
      this.addBatchDrawerShow = true
      this.fileList = []
      this.userList = []
    },

    tableUpdate(row) {
      if (!this.phoneNumShow) {
        this.cleartextShow('访客查询')
        return
      }
      row.usualExtraType = ""
      row.usualExtraBegin = ""
      row.usualExtraEnd = ""
      if (row.usualTimeLimit) {
        let usualTimeLimit = JSON.parse(row.usualTimeLimit)
        row.usualExtraType = usualTimeLimit.type
        row.usualExtraBegin = usualTimeLimit.beginTime
        row.usualExtraEnd = usualTimeLimit.endTime
      }
      this.selectVisitor = JSON.parse(JSON.stringify(row))
      this.updateDrawerShow = true
    },

    tableDel(row) {
      console.log("tableDel =>", row.id)
      deleteVisitor(row.id).then(({data}) => {
        console.log("deleteVisitor result =>", data)
        if (data.code === 200) {
          this.$message.success("删除成功")
          this.tableAllData = this.tableAllData.filter(item => item.id !== row.id)
          this.tableShowData = this.tableShowData.filter(item => item.id !== row.id)
          this.initPaginationTable()
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(err => {
        console.log("deleteVisitor err =>", err)
        this.showNetErrMsg();
      })
    },

    onUpdateVisitorClick() {
      console.log("onUpdateVisitorClick")
      let contactEmployeeCode = this.selectVisitor.contactEmployee ? this.selectVisitor.contactEmployee.code : ""
      let postData = {
        id: this.selectVisitor.id,
        name: this.selectVisitor.name,
        tel: this.selectVisitor.tel,
        company: this.selectVisitor.company,
        ic: this.selectVisitor.ic,
        tag: this.selectVisitor.tag,
        email: this.selectVisitor.email,
        car: this.selectVisitor.car,
        address: this.selectVisitor.address,
        comments: this.selectVisitor.comments,
        type: this.selectVisitor.type,
        contactEmployeeCode: contactEmployeeCode,
        usualTimeLimit: "",
      }

      if (this.selectVisitor.type === "usual") {
        if (!this.selectVisitor.usualExtraType) {
          this.$message.error("请选择有效期限")
          return
        }
        if (this.selectVisitor.usualExtraType === "have") {
          if (!this.selectVisitor.usualExtraBegin || !this.selectVisitor.usualExtraEnd) {
            this.$message.error("请选择开始和结束时间")
            return
          }
          let begin = new Date(this.selectVisitor.usualExtraBegin)
          let end = new Date(this.selectVisitor.usualExtraEnd)
          if (begin > end) {
            this.$message.error("结束时间需要大于开始时间")
            return
          }
        }

        let limit = {
          type: this.selectVisitor.usualExtraType,
          beginTime: this.selectVisitor.usualExtraBegin,
          endTime: this.selectVisitor.usualExtraEnd,
        }
        postData.usualTimeLimit = JSON.stringify(limit)
      }
      if (!this.checkoutVisitorValidate(this.selectVisitor)) {
        console.log("validate error, error submit!!")
        return false
      }

      this.doUpdateVisitor(postData)
      this.updateDrawerShow = false
    },

    addAddVisitorClick() {
      console.log("addAddVisitorClick")
      this.$refs.addForm.validate((valid) => {
        if (valid) {

          if (!this.checkoutVisitorValidate(this.form)) {
            console.log("validate error, error submit!!")
            return false
          }
          addVisitor(this.addForm).then(({data}) => {
            console.log("addVisitor result =>", data)
            if (data.code === 200) {

              this.$message.success("添加成功")
              this.addDrawerShow = false
              this.tableAllData.unshift(data.data)
              this.initPaginationTable()
            } else {
              this.showServerErrMsg(data.code);
            }
          }).catch(err => {
            console.log("addVisitor err =>", err)
            this.showNetErrMsg();
          })
        } else {
          console.log('validate error, error submit!!');
          return false;
        }
      });
    },


    doUpdateVisitor(data) {
      updateVisitor(data).then(({data}) => {
        console.log("updateVisitor result =>", data)
        if (data.code === 200) {
          this.$message.success("修改成功")
          this.refreshTableData()
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(err => {
        console.log("updateVisitor err =>", err)
        this.showNetErrMsg();
      })
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    downloadExcel() {
      const XLSX = require('xlsx');
      let mData = [['*访客姓名', '*手机号码', '*公司名称', '身份证号', '国籍', '护照号码', '电子邮箱', '车牌号码', '地址信息', '备注信息']]

      let workbook = XLSX.utils.book_new();
      let sheet = XLSX.utils.aoa_to_sheet(mData);
      XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");

      const wbout = XLSX.write(workbook, {bookType: 'xlsx', type: 'binary'});
      const blob = new Blob([this.s2ab(wbout)], {type: 'application/octet-stream'});

      let link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = '黑名单访客模板.xlsx';

      link.click();

      URL.revokeObjectURL(link.href);
    },

    handleFileChange(file, fileList) {
      console.log("@@@", "handleFileChange file", file, fileList);
      let result = file.name.indexOf(".xlsx")
      if (result) {
        this.dealExcel(file)
      } else {
        this.$message.error('请上传正确的表格');
      }
    },

    dealExcel(file) {
      console.log("@@@", "dealExcel file", file);
      const XLSX = require('xlsx');

      let rABS = true;
      let reader = new FileReader();
      let ctx = this
      reader.onload = function (e) {
        let data = e.target.result

        if (!rABS) data = new Uint8Array(data);
        let workbook = XLSX.read(data, {type: rABS ? 'binary' : 'array'});
        let firstSheetName = workbook.SheetNames[0]
        const sheet = workbook.Sheets[firstSheetName]
        const result = XLSX.utils.sheet_to_json(sheet)
        console.log("@@@@", "XLSX.result", result);
        ctx.userList = result
      }
      if (rABS) reader.readAsBinaryString(file.raw); else reader.readAsArrayBuffer(file.raw);
    },


    onSubmitAddBatch() {
      let visitorList = []

      this.userList.forEach(item => {
        visitorList.push({
          name: item["*访客姓名"],
          tel: item["*手机号码"],
          company: item["*公司名称"],
          ic: item["身份证号"],
          nationality: item["国籍"],
          tag: item["护照号码"],
          email: item["电子邮箱"],
          car: item["车牌号码"],
          address: item["地址信息"],
          comments: item["备注信息"],
          type: "black"
        })
      })

      for (let i = 0; i < visitorList.length; i++) {
        let item = visitorList[i]
        if (!this.checkoutVisitorValidate(item)) {
          this.$message.error("访客 " + item.name + ", " + item.tel + " 数据有误，请检查")
          console.log("validate error, error submit!!")
          return false
        }
      }


      addBatchVisitor(visitorList).then(({data}) => {
        console.log("addBatchVisitor result =>", data)
        if (data.code === 200) {
          this.$message.success("添加成功")
          this.addBatchDrawerShow = false
          this.refreshTableData()
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(err => {
        console.log("addBatchVisitor err =>", err)
        this.showNetErrMsg();
      })
    },

    onVisitorTypeSelectChange(val) {
      console.log("onVisitorTypeSelectChange", val)
      this.selectVisitor.type = val
      if (val !== "usual") {
        this.selectVisitor.usualExtraType = ""
        this.selectVisitor.usualExtraBegin = ""
        this.selectVisitor.usualExtraEnd = ""
      }
    },
  },

  computed: {
    hasCommitPermission: function () {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("VISITOR_MANAGE_MODIFY")
        default:
          return false
      }
    },
  },

}
</script>
<style scoped lang="less">
.page {
  height: 100%;
  width: 100%;


  .main-area {
    height: 100%;
    width: 100%;

    .header-area {
      display: flex;
      align-items: start;
      flex-direction: row;
      justify-content: space-between;
      height: 50px;

      .el-input {
        width: 300px;
      }
    }

    .mainContainer {
      height: calc(100vh - 170px);
      background-color: white;
      overflow: auto;
    }
  }
}

.visitor-drawer {
  .drawer-header {
    height: 60px;
    background-color: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .drawer-content {
    height: calc(100vh - 120px);
    overflow: auto;

    .drawer-form {
      margin: 20px;
    }
  }

  .drawer-bottom {
    height: 60px;
    background-color: #f5f7fa;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.my-header {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 150px;

  .header-title-box {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

.my-el-main {
  height: calc(100% - 210px);
  box-sizing: border-box;
  padding: 0;
}

.main-content {
  flex: 1 0 auto;

}

.footer-content {
  text-align: center;
  flex: 0 0 auto;
  margin-bottom: 20px;
}

.btn-area {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
}

.table-area {
}

.el-select {
  width: 380px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 380px;
}
</style>
